export default __webpack_public_path__ + "static/media/img2.80e0fff1.png";